import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material'
import { Subject } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { InstructionService, AppService, DialogService } from '../../../../../services'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { ConfirmComponent } from '../confirm-dialog/confirm.component'

const KEY = 'instruction-personne-dialog'

@Component({
  selector: 'atyl-instruction-personne',
  templateUrl: './instruction-personne.component.html',
  styleUrls: ['./instruction-personne.component.scss']
})
@Stringable({
  path: 'views/partials/layout/dialogs/instruction-personne-dialog',
  key: KEY,
})
export class InstructionPersonneComponent extends BaseDialogComponent implements OnInit {

  @StringableValues(KEY)
  strings: any
  instruction: any
  iddossier: any
  selectedInstructeur: any
  comment: any
  title: any
  private debounce: Subject<string> = new Subject();
  selectedDemandeType: any
  user: any
  
  constructor(
    public dialogRef: MatDialogRef<InstructionPersonneComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    private instructionService: InstructionService,
    changeDetectorRef: ChangeDetectorRef,
    dialogService: DialogService,
    public dialog: MatDialog
   
  ) {
    super(dialogRef, dialogService, changeDetectorRef)
  }

  ngOnInit() {
    this.instruction = this.data.instruction
    this.user = this.data.user
    if (this.instruction && this.instruction.comment)
      this.comment = this.instruction.comment;
    if (this.instruction && this.instruction.titre)
      this.title = this.instruction.titre;
        
    this.iddossier = this.data.iddossier
    if (this.instruction.type && this.instruction.type.professions && this.data.iddossier) {
      let professions = []
      this.instruction.type.professions.forEach(element => {
        professions.push(element.key)
      })
      this.appService.getUsersByProfressions(professions, this.iddossier).subscribe((res) => {
        this.instruction.possibleTiers = res.result
        if (this.instruction && this.instruction.possibleTiers) {
          this.instruction.possibleTiers.forEach(element => {
            if (this.instruction.instructeur.ID === element.ID)
              this.instruction.selectedTier = element
          })
        }
        this.changeDetectorRef.detectChanges()
      })

      this.debounce.pipe(
        debounceTime(1000)
      ).subscribe(search => {
        if (search.length > 0) {
          this.appService.getUsersByProfressions(professions, this.iddossier, search).subscribe((result) => {
            this.instruction.possibleTiers = result.result
            this.changeDetectorRef.detectChanges()
          })
        }

      })
      if (this.instruction) {
        let _steps=[];
        if (this.instruction.transitions
        
        ) {
           for(let i=0;i<this.instruction.transitions.length;i++) {
                _steps.push(this.instruction.transitions[i].to.ID);
               // this.instruction.transitions[i].demandes=[];
               this.instruction.transitions[i].disabled=true;
            }
        }
        let _options={
            steps:_steps
        }
        console.log("transitions",this.instruction.ID,_options)
        this.instructionService.transitions(this.instruction.ID,_options).subscribe((result: JSONRpcResponse) => {
             console.log("transitions result",result.result) 
             if (this.instruction.transitions ) {
                for(let i=0;i<this.instruction.transitions.length;i++) {
                    if (result.result[this.instruction.transitions[i].to.ID]!=undefined 
                    && Array.isArray(result.result[this.instruction.transitions[i].to.ID]))
                       this.instruction.transitions[i].demandes=result.result[this.instruction.transitions[i].to.ID][0];
                   
                    this.instruction.transitions[i].disabled=false;
                    
                }
                this.changeDetectorRef.detectChanges()
               } 
             
           }
        )
      }
    }
  }


  displayAutoSelectListInstru(key?: any): string | undefined {
    let selected
    if (this.instruction && this.instruction.possibleTiers) {
      this.instruction.possibleTiers.forEach((select) => {
        if (key && select.ID === key.ID)
          selected = select
      })
    }
    return selected ? selected.NOM + ' ' + (selected.PRENOM ? selected.PRENOM : '') : undefined
  }

  triggerAutocompSelectionList(search: any) {
    this.debounce.next(search)
  }

 
  
  updateInstructeurToUser(to_me:boolean=true){
	
	let toConfirm = true;
       
        if(toConfirm){
          const confDialogRef = this.dialog.open(ConfirmComponent, {
            data : {
              libelle : this.strings.messageComfirm
            }
          });
          confDialogRef.afterClosed().subscribe(res => {
				if(res === "true"){
					this.instruction.comment=this.comment;
					this.instruction.titre=this.title;
					let ins=this.user;
					if (!to_me)
	              			ins =this.selectedInstructeur;
		              
					let dataReturn = {
					      instructeur: ins,
					      titre: this.title,
					      comment: this.comment,
					     
					 }
					 console.log("updateInstructeurToUser beofre close",dataReturn);
					  this.dialogRef.close(dataReturn);
			   }
           /* if(res === "true"){
              if (to_me)
              	this.instruction.instructeurid = this.user.id;
              else {
	
	
			   }
              this.appService.setInstruction(this.instruction).subscribe((res) => {
                
                
                 
               
              });
              
            }
            */
            
          });
        }
        
        
        
     }
  
}
